import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

export interface InvoiceItGetParams {
  cust_id?: number;
  proj_id?: number;
  act_id?: number;
  emp_id?: number;
  from: string;
  to: string;
  detailMode?: string;
  groupMode?: string;
}

export interface InvoiceItInsertParams {
  cust_id: number;
  from: string;
  to: string;
  groupMode?: string;
}

@Injectable({
  providedIn: 'root',
})
export class InvoiceItService {
  constructor(@Inject(HttpClient) private http: HttpClient) {}

  get<T = unknown>(params: InvoiceItGetParams): Observable<T[]> {
    let httpParams = new HttpParams();

    if (params.proj_id) httpParams = httpParams.set('proj_id', String(params.proj_id));
    if (params.act_id) httpParams = httpParams.set('act_id', String(params.act_id));
    if (params.emp_id) httpParams = httpParams.set('emp_id', String(params.emp_id));
    if (params.detailMode) httpParams = httpParams.set('detailMode', String(params.detailMode));
    if (params.groupMode) httpParams = httpParams.set('groupMode', String(params.groupMode));

    // cust_id is in the path, but might be optional/missing in some cases?
    // Based on restServices.js: "api/invoiceit/:cust_id/:from/:to"
    // If cust_id is missing, it might fail or use a different route?
    // In InvoiceCtrl, it sets params.cust_id based on groupMode.
    // If groupMode is 'C' or 'KU', it sets cust_id.

    const custId = params.cust_id !== undefined ? params.cust_id : '';

    return this.http.get<any[]>(`/api/invoiceit/${custId}/${params.from}/${params.to}`, {
      params: httpParams,
    });
  }

  insert(params: InvoiceItInsertParams, body: any): Observable<any> {
    return this.http.post<any>(
      `/api/invoiceit/${params.cust_id}/${params.from}/${params.to}`,
      body,
      {
        params: { groupMode: params.groupMode },
      }
    );
  }
}
